import { render } from "./ColorPickerFooter.vue?vue&type=template&id=da30defc&scoped=true"
import script from "./ColorPickerFooter.vue?vue&type=script&lang=js"
export * from "./ColorPickerFooter.vue?vue&type=script&lang=js"

import "./ColorPickerFooter.vue?vue&type=style&index=0&id=da30defc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da30defc"]])

export default __exports__